// @flow

import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { parse, isPast } from "date-fns";

import Config from "../../constants/Config";
import convertJsonToCsv from "../../utils/convertJsonToCsv";
import LinkHandler from "../atoms/LinkHandler";
import Icon from "../atoms/Icon";
import Button from "../atoms/Button";

interface PropsType extends RouteComponentProps<any> {
    attendees: any;
    isClubExec?: boolean;
    canManageEvents?: boolean;
    event: any;
    eventStatus: any;
    toggleModalState: () => void;
    scanTicketDisabled: boolean;
}

const NavManageEvent = (props: PropsType) => {
    const totalAttendees = props.attendees ? props.attendees.length : 0;
    const checkedInAttendees =
        props.attendees && props.attendees.length
            ? props.attendees.filter(attendee => {
                  return attendee.is_checkin;
              }).length
            : null;
    const eventName = props.event ? props.event.post_title : "";
    const eventEndDate =
        props.event.acf && props.event.acf.end_date
            ? parse(props.event.acf.end_date, "dd/MM/yyyy h:mm aa", new Date())
            : null;
    const isPastEvent = eventEndDate && isPast(eventEndDate);
    const isDraftEvent = props.eventStatus === "draft";

    const handleDownloadMemberListClick = () => {
        if (props.attendees) {
            const mappedCsvFields = props.attendees.map(attendee => {
                return {
                    date: attendee.date,
                    type: attendee.type,
                    first_name: attendee.first_name,
                    last_name: attendee.last_name,
                    preferred_name: attendee.preferred_name,
                    email: attendee.email,
                    mobile: attendee.mobile,
                    is_checkin: attendee.is_checkin,
                    checkin_date: attendee.checkin_date,
                    comment: attendee.comment,
                    ticket_name: attendee.ticket_name,
                    ticket_price: attendee.ticket_price
                        ? `$${attendee.ticket_price.toFixed(2)}`
                        : "",
                    promo_code: attendee.promo_code,
                    dietary_requirements: attendee.dietary_requirements,
                    tshirt_size: attendee.tshirt_size,
                    teammate_request: attendee.teammate_request,
                    accessibility_requirements:
                        attendee.accessibility_requirements,
                    emergency_contact: attendee.emergency_contact,
                    under_18: attendee.under_18,
                };
            });

            convertJsonToCsv(mappedCsvFields, `${eventName} - Attendees`);
        }
    };

    return (
        <div id="manage-event-nav" className="nav-manage-event">
            {props.isClubExec ? (
                <LinkHandler
                    className="nav-manage-event__tab"
                    to={`${Config.routes.manageEvent}/${props.match.params.id}/edit`}
                    target=""
                    disabled={isPastEvent}
                >
                    <span className="nav-manage-event__tab__inner">
                        <span className="nav-manage-event__tab__icon">
                            <Icon name="edit" />
                        </span>
                        <span className="nav-manage-event__tab__label">
                            Edit event details
                        </span>
                    </span>
                </LinkHandler>
            ) : null}

            {props.isClubExec ? (
                <LinkHandler
                    className="nav-manage-event__tab"
                    to={props.event.url}
                    target="_blank"
                    disabled={isDraftEvent}
                >
                    <span className="nav-manage-event__tab__inner">
                        <span className="nav-manage-event__tab__icon">
                            <Icon name="page" />
                        </span>
                        <span className="nav-manage-event__tab__label">
                            View live page
                        </span>
                    </span>
                </LinkHandler>
            ) : null}

            {props.isClubExec ? (
                <LinkHandler
                    className="nav-manage-event__tab"
                    onClick={handleDownloadMemberListClick}
                    disabled={!props.attendees || !props.attendees.length}
                >
                    <span className="nav-manage-event__tab__inner">
                        <span className="nav-manage-event__tab__icon">
                            <Icon name="download" />
                        </span>
                        <span className="nav-manage-event__tab__label">
                            Download attendee list
                        </span>
                    </span>
                </LinkHandler>
            ) : null}

            <div className="nav-manage-event__right-content">
                <div className="nav-manage-event__right-content__checked-in">
                    <div className="nav-manage-event__right-content__label">
                        Checked in
                    </div>
                    <div className="nav-manage-event__right-content__data">
                        <span className="nav-manage-event__right-content__count">
                            {checkedInAttendees}
                        </span>{" "}
                        <span className="nav-manage-event__right-content__total">
                            / {totalAttendees}
                        </span>
                    </div>
                </div>
                <div className="nav-manage-event__right-content__scan">
                    <Button
                        type="button"
                        styles={["green"]}
                        aria-label="Scan QR"
                        onClick={() => props.toggleModalState()}
                        disabled={props.scanTicketDisabled}
                    >
                        <span
                            className={`nav-manage-event__right-content__scan__qr ${
                                props.scanTicketDisabled
                                    ? "nav-manage-event__right-content__scan__qr--disabled"
                                    : ""
                            }`}
                        >
                            <Icon name="qr" />
                        </span>
                        <span className="nav-manage-event__right-content__scan__text">
                            Scan ticket QR code
                        </span>
                    </Button>
                </div>
            </div>
        </div>
    );
};

NavManageEvent.preload = ({
    location,
    passed: { store },
}: any): Promise<any> => {
    return Promise.all([]);
};

export default withRouter(NavManageEvent);
